export default __webpack_public_path__ + "static/media/secret_logo.c6411944.png";